export default __webpack_public_path__ + "static/People_Placeholder_2.0@2x-a1911bbc63a9e464788d778481f71bf0.jpg";